import './static/_all.scss';

import { getViewer, registerViewer } from './components/viewers';
import { DAM_SERVICES_NAMESPACE } from './constants';
import DamRoutes from './routes';
import { DamAttributesService } from './services/attributesService';
import { FilesService } from './services/filesService';
import { FileTasksService } from './services/fileTasksService';
import { FoldersService } from './services/foldersService';

/**
 * Function to install module in Vue instance
 * @params {Object} Vue: Vue instance
 * @params {Object} settings: object who contains router and store instance
 * */
export function install(Vue, settings) {
  if (!settings || !settings.store || !settings.router) {
    throw new Error('Please initialise plugin with a Vuex store and a Vue router.');
  }
  settings.router.addRoutes(DamRoutes);

  settings.extensionPoints.registerExtensionPoint('dam', {
    viewers: {
      registerViewer,
      getViewer,
    },
  });

  function addNamespacedService(serviceName, service) {
    return settings.services.addNamespacedService(DAM_SERVICES_NAMESPACE, serviceName, service);
  }

  addNamespacedService('foldersService', new FoldersService());
  addNamespacedService('filesService', new FilesService());
  addNamespacedService('damAttributes', new DamAttributesService());
  addNamespacedService('fileTasks', new FileTasksService());
}

export default install;
